type CopyIconProps = {
  width?: number;
  height?: number;
};

export default function CopyIcon({ width = 20, height = 20 }: CopyIconProps) {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_478_5089)">
          <path
            d="M16.6667 7.5H9.16667C8.24619 7.5 7.5 8.24619 7.5 9.16667V16.6667C7.5 17.5871 8.24619 18.3333 9.16667 18.3333H16.6667C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667V9.16667C18.3333 8.24619 17.5871 7.5 16.6667 7.5Z"
            stroke="#0033AD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.16663 12.4998H3.33329C2.89127 12.4998 2.46734 12.3242 2.15478 12.0117C1.84222 11.6991 1.66663 11.2752 1.66663 10.8332V3.33317C1.66663 2.89114 1.84222 2.46722 2.15478 2.15466C2.46734 1.8421 2.89127 1.6665 3.33329 1.6665H10.8333C11.2753 1.6665 11.6992 1.8421 12.0118 2.15466C12.3244 2.46722 12.5 2.89114 12.5 3.33317V4.1665"
            stroke="#0033AD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_478_5089">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
